import type { FC } from 'react';

import { Avatar } from '../../ui/Avatar';

import { useCommunityDisplayName } from '../../../_hooks/useCommunityDisplayName';
import { useCommunityLogoUrl } from '../../../_hooks/useCommunityLogoUrl';

export const SidebarHeader: FC = () => {
  const displayName = useCommunityDisplayName();
  const logoUrl = useCommunityLogoUrl();

  return (
    <div className="flex items-center gap-2">
      <Avatar src={logoUrl} alt={displayName} className="size-10" fallbackClassName="bg-gray-300" />
      <span className="text-[15px] font-semibold leading-5 tracking-[-0.15px] truncate">{displayName}</span>
    </div>
  );
};
